import { createHttpLink as apolloCreateHttpLink } from '@apollo/client';
import { getEnv } from 'services/environmentVariables';

const createHttpLink = () =>
  apolloCreateHttpLink({
    uri: getEnv('GRAPHQL_URI'),
  });

export default createHttpLink;
